import React from "react";
import CasesTable from "@/components/CasesTable";
import { useI18n } from "@/context/I18nContext";

export default function PortalMessages() {
  const { lang } = useI18n();
  const L = (it, en, de) => (lang === "en" ? en : lang === "de" ? (de ?? it) : it);
  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-heading text-2xl font-medium text-white">{L("Messaggi", "Messages", "Nachrichten")}</h2>
        <p className="mt-1 text-slate-400">{L("Apri una pratica per leggere e inviare messaggi sicuri al team.", "Open a case to read and send secure messages to the team.", "Öffnen Sie einen Fall, um sichere Nachrichten an das Team zu lesen und zu senden.")}</p>
      </div>
      <CasesTable endpoint="/cases" basePath="/portal/cases" />
    </div>
  );
}
